import { Skeleton, SkeletonAvatar, SkeletonInput } from 'components';
import React from 'react';
import styled from 'styled-components';
import { featureEnabled } from 'utils';
import {
  Section,
  DetailsContainer,
  Divider,
  PadRight,
  FlexAlign,
  FlexColumn,
  UserSectionBottom,
  UserSectionTop,
  Flex,
  VerticalContactContainer,
} from '../styles';

const UserSectionLoadingSkeleton: React.FC = () => !featureEnabled('supraAutoCoopFeature') ? (
    <Section>
      <UserSectionTop>
        <PadRight>
          <SkeletonAvatar size={93} />
        </PadRight>
        <FlexColumn>
          <FlexAlign>
            <FlexColumn>
              <NameSkeleton />
              <Skeleton
                title={false}
                paragraph={{ rows: 3, width: [200, 100, 80] }}
              />
            </FlexColumn>
          </FlexAlign>
        </FlexColumn>
      </UserSectionTop>
      <Divider />
      <UserSectionBottom>
        <Flex style={{ gap: '8px', width: '100%' }}>
          <Skeleton title={false} paragraph={{ rows: 1, width: [110] }} />
          <Skeleton title={false} paragraph={{ rows: 1, width: [110] }} />
          <Skeleton title={false} paragraph={{ rows: 1, width: [110] }} />
        </Flex>
        <Skeleton
          title={false}
          paragraph={{ rows: 4, width: [80, 70, 90, 80] }}
        />
      </UserSectionBottom>
    </Section>
  ) : (
    <>
      <Section>
        <UserSectionTop>
          <PadRight>
            <SkeletonAvatar size={93} />
          </PadRight>
          <FlexColumn>
            <FlexAlign>
              <FlexColumn>
                <NameSkeleton />
                <Skeleton
                  title={false}
                  paragraph={{ rows: 2, width: [110, 220] }}
                />
              </FlexColumn>
            </FlexAlign>
          </FlexColumn>
        </UserSectionTop>
      </Section>
      <DetailsContainer>
        <Section>
          <VerticalContactContainer>
            <FlexColumn style={{ gap: '8px', width: '100%' }}>
              <Skeleton title paragraph={{ rows: 1, width: [110] }} />
              <Skeleton title={false} paragraph={{ rows: 1, width: [110] }} />
            </FlexColumn>
          </VerticalContactContainer>
        </Section>
        <Section>
          <VerticalContactContainer>
            <FlexColumn style={{ gap: '8px', width: '100%' }}>
              <Skeleton title paragraph={{ rows: 1, width: [130] }} />
              <Skeleton title={false} paragraph={{ rows: 1, width: [130] }} />
            </FlexColumn>
          </VerticalContactContainer>
        </Section>
      </DetailsContainer>
    </>
  );

const NameSkeleton = styled(SkeletonInput)`
  border-radius: 5px;
  margin-bottom: 10px;
`;

export default UserSectionLoadingSkeleton;
